import React from "react";

import { PurchaseOrder } from "../../../../models/purchase.order";
import { ViewOnly } from "../../../../types";
import { ShipmentType } from "../../../../util/enums";
import ShipmentOrders from "../../../Generic/ShipmentOrders";
import { PurchaserOrderFrom } from "../../../Generic/ShipmentOrders/types";
import { useShipmentOrdersRecourse } from "../../context/AvailableOrders";
import { useShipmentContext } from "../../hooks/useShipmentContext";
import ShipmentTooltip from "../components/ShipmentTooltips";
import useStyles from "./styles";

interface ShipmentPuchaseOrdersProps {
  purchaseOrders: PurchaseOrder[];
  onAddPurchaseOrder?: (orders: PurchaseOrder[]) => void;
  onRemovePurchaseOrder?: (order: PurchaseOrder) => void;
  viewOnly: ViewOnly;
  loadingOrders: boolean;
  fromMaintenance?: boolean;
}

const ShipmentPuchaseOrders: React.FC<ShipmentPuchaseOrdersProps> = (props) => {
  const {
    purchaseOrders,
    onAddPurchaseOrder,
    onRemovePurchaseOrder,
    viewOnly: viewMode,
    loadingOrders,
    fromMaintenance,
  } = props;
  const classes = useStyles();
  const { shipment } = useShipmentContext();
  const { orderList, refetchOrderList, isLoading: loadindOrderList } = useShipmentOrdersRecourse();
  const disableByType = () => {
    if (!shipment?.shipmentType) return true;

    if (
      shipment?.shipmentType === ShipmentType.SEA ||
      shipment?.shipmentType === ShipmentType.AIR
    ) {
      return !shipment?.portOfLoading || !shipment?.portOfDischarge;
    }

    return !shipment?.origin || !shipment?.destination;
  };

  return (
    <div className={classes.mainDiv} data-cy="orders-container">
      <ShipmentOrders
        purchaseOrders={purchaseOrders}
        viewOnly={viewMode}
        onAddPurchaseOrder={onAddPurchaseOrder}
        onRemovePurchaseOrder={onRemovePurchaseOrder}
        loadingOrders={loadingOrders}
        orderList={orderList}
        refetchOrderList={refetchOrderList}
        loadingOrderList={loadindOrderList}
        addButton={{
          tooltip: <ShipmentTooltip />,
          disableButton: !shipment?.shipmentType || !shipment?.incoterm || disableByType(),
        }}
        calledFrom={PurchaserOrderFrom.SHIPMENT}
        fromMaintenance={fromMaintenance}
        showOrderStatus={!shipment?.bookingId && !shipment?.isBooking}
      />
    </div>
  );
};

export default ShipmentPuchaseOrders;
